import { IconStatus } from "../../../constants";
import { OwcIcon, OwcTypography } from "@one/react";
import styles from "../../../components/shared/CustomEventCalendar.module.scss";

const BookingScheduleStatus = () => {
  return (
    <div className={styles.customEventStatus}>
      {IconStatus.map(
        (item) =>
          !["Available", "Booking", "Reservation"].includes(item.text) && (
            <div className={styles.customEventIconText}>
              <div style={{ position: "relative", display: "inline-block" }}>
                <OwcIcon
                  type="outlined"
                  name={item.icon}
                  className={styles.customEventStatusIcon}
                  style={{
                    backgroundColor: item.backgroundColor,
                    color: item.color,
                  }}
                />
                {item.text === "First time user" && item.firstTimeUserBadge && (
                  <div
                    style={{
                      position: "absolute",
                      top: "23px",
                      left: "23px",
                      width: "17px",
                      height: "17px",
                      borderRadius: "6px",
                      backgroundColor: item.firstTimeUserBadge.backgroundColor,
                      color: item.firstTimeUserBadge.textColor,
                      borderWidth: "1px",
                      borderStyle: "dashed",
                      borderColor: "#FBFBFA",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "8px",
                      fontWeight: "500",
                      lineHeight: "100%",
                      boxSizing: "border-box",
                    }}
                  >
                    JD
                  </div>
                )}
              </div>
              <OwcTypography variant="button">
                {item.text}
              </OwcTypography>
            </div>
          ),
      )}
    </div>
  );
};

export default BookingScheduleStatus;
